// extracted by mini-css-extract-plugin
export default {"spacing2":"styles_spacing2__07GPi","grid1":"styles_grid1__7Njb6","vehicle-type-container":"styles_vehicle-type-container__-UKFj"};